import React, { useState } from 'react';
import styled from 'styled-components';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button, TextField } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { generateFolderId, addFolder, setCurrentFolder } from '../redux/folderDbSlice';
import { generateRelationUserFolderId, addRelationUserFolder } from '../redux/relationUserFolderDbSlice';
import useCurrentUserId from '../hooks/useCurrentUserId';
import useAllFoldersDb from '../hooks/useAllFoldersDb';

const FolderNameTextField = styled(TextField)`
  width: 90%;
  `

type AddFolderDialogProps = {
  open: boolean;
  onClose: () => void;
}
const AddFolderDialog: React.FC<AddFolderDialogProps> = ({open, onClose}) => {
  const dispatch = useDispatch();
  const currentUserId = useCurrentUserId();
  const [folderIds] = useAllFoldersDb(currentUserId);
  const [value, setValue] = useState('新しいフォルダ');

  const addFolderExe = () => {
    const folderId = generateFolderId();
    const relationId = generateRelationUserFolderId();
    dispatch(addFolder({id: folderId, name: value}));
    dispatch(addRelationUserFolder({id: relationId, userId: currentUserId || 'no user', folderId: folderId, order: folderIds.length }));
    dispatch(setCurrentFolder(folderId));
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle></DialogTitle>
      <DialogContent style={{overflow: 'hidden'}}>
        <FolderNameTextField label="新しいフォルダの名前" variant="outlined" defaultValue={value}
                                onChange={(ev) => setValue(ev.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button color='primary' onClick={addFolderExe}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddFolderDialog;
